import { render, staticRenderFns } from "./notification-panel-item.vue?vue&type=template&id=7cc0dc8e&scoped=true&"
import script from "./notification-panel-item.vue?vue&type=script&lang=js&"
export * from "./notification-panel-item.vue?vue&type=script&lang=js&"
import style0 from "./notification-panel-item.vue?vue&type=style&index=0&id=7cc0dc8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc0dc8e",
  null
  
)

export default component.exports